<template>
    <div id="produk-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Testimoni',
                    to: { path: '/testimoni' },
                    exact: true,
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Testimoni'
                        : 'Ubah Testimoni',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Testimoni" : "Ubah Testimoni" }}
        </h3>

        <v-card style="border">
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            url
                                                ? url
                                                : require('@/assets/img/unavailable.png')
                                        "
                                        :key="keyimg"
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 font-weight-bold dark--text"
                                color="white"
                            >
                                Upload *
                            </v-btn>
                            <input
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Rasio Foto 1:1 (HD)
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="9">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item
                                v-if="!$route.query.id"
                                two-line
                                class="pa-0"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Email
                                    </v-list-item-title>
                                    <v-text-field
                                        class="pb-2"
                                        placeholder="Email User"
                                        v-model="emailInput"
                                        maxLength="50"
                                        persistent-hint
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="$route.query.id"
                                two-line
                                class="pa-0"
                            >
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Email
                                    </v-list-item-title>
                                    <v-text-field
                                        class="pb-2"
                                        placeholder="Email User"
                                        v-model="emailInput"
                                        maxLength="50"
                                        persistent-hint
                                        outlined
                                        disabled
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama
                                    </v-list-item-title>
                                    <v-text-field
                                        class="pb-2"
                                        placeholder="Nama User"
                                        v-model="data.student_name"
                                        maxLength="50"
                                        persistent-hint
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-bold">
                                        Jenjang
                                    </v-list-item-title>

                                    <v-radio-group
                                        row
                                        v-model="data.level"
                                        @change="data.grade = []"
                                        mandatory
                                    >
                                        <v-radio
                                            label="SD"
                                            value="SD"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            label="SMP"
                                            value="SMP"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            label="SMA"
                                            value="SMA"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-bold">
                                        Kelas
                                    </v-list-item-title>

                                    <v-radio-group
                                        row
                                        v-if="data.level === 'SD'"
                                        v-model="data.grade"
                                    >
                                        <v-radio
                                            v-for="i in 6"
                                            :key="i"
                                            :label="'' + i"
                                            :value="i"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>

                                    <v-radio-group
                                        row
                                        v-if="data.level === 'SMP'"
                                        v-model="data.grade"
                                    >
                                        <v-radio
                                            v-for="i in 3"
                                            :key="i"
                                            :label="'' + (i + 6)"
                                            :value="i + 6"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>

                                    <v-radio-group
                                        row
                                        v-if="data.level === 'SMA'"
                                        v-model="data.grade"
                                    >
                                        <v-radio
                                            v-for="i in 3"
                                            :key="i"
                                            :label="'' + (i + 9)"
                                            :value="i + 9"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-bold">
                                        Rating
                                    </v-list-item-title>

                                    <v-radio-group row v-model="data.rating">
                                        <v-radio
                                            v-for="i in 5"
                                            :key="i"
                                            :label="'' + i"
                                            :value="i"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Nama Paket
                                    </v-list-item-title>
                                    <v-select
                                        :items="packagesList"
                                        item-text="package_name"
                                        item-value="package_id"
                                        class="pb-2"
                                        placeholder="Pilih paket"
                                        outlined
                                        v-model="data.package_id"
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Deskripsi Testimoni
                                    </v-list-item-title>
                                    <v-textarea
                                        placeholder="Deskripsi testimoni"
                                        v-model="data.testimoni"
                                        :maxlength="500"
                                        :counter="500"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Is Show
                                    </v-list-item-title>
                                    <v-checkbox
                                        label="Is Show"
                                        v-model="data.is_show"
                                        :false-value="false"
                                        :true-value="true"
                                        class="pa-0 ma-0"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-divider></v-divider>

                            <v-card-actions class="py-2 mt-5">
                                <v-spacer></v-spacer>

                                <v-btn
                                    text
                                    @click="
                                        $router.push({ path: '/testimoni' })
                                    "
                                >
                                    Batal
                                </v-btn>

                                <v-btn
                                    color="primary"
                                    depressed
                                    @click="upload()"
                                >
                                    Simpan
                                </v-btn>
                            </v-card-actions>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-card>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";
import { applyOssCredentials } from "@/modules/global/services/oss";
import debounce from "lodash/debounce";
import uniqid from "uniqid";

export default {
    name: "testimoni-form",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            queryId: null,
            selectedPicture: null,
            data: {
                student_id: "",
                student_picture: "",
                level: "",
                package_name: null,
                package_id: null,
                testimoni: null,
                grade: null,
                student_name: "",
                rating: null,
                student_email: "",
                is_show: false,
            },
            url: null,
            imageFile: null,
            keyimg: 0,
            packagesList: [],
            emailInput: "",
        };
    },

    watch: {
        emailInput: debounce(function (newEmail) {
            if (this.isValidEmail(newEmail)) {
                this.getDetailUserTransaction(newEmail);
            }
        }, 500),
    },

    mounted: function () {
        if (this.$route.query.id) {
            this.queryId = this.$route.query.id;
            this.fetchData();
        }
    },

    methods: {
        fetchData: function () {
            var context = this;
            var queryId = this.queryId;
            this.isLoading = true;

            SalesService.getDetailTestimoni(queryId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    (context.data.id = result.data.id),
                        (context.data.student_id = result.data.student_id),
                        (context.data.student_name = result.data.student_name),
                        (context.data.student_picture =
                            result.data.student_picture),
                        (context.url = result.data.student_picture),
                        (context.data.student_email =
                            result.data.student_email),
                        (context.emailInput = result.data.student_email),
                        (context.data.level = result.data.level),
                        (context.data.grade = result.data.grade),
                        (context.data.rating = result.data.rating),
                        (context.data.package_id = result.data.package_id),
                        (context.data.testimoni = result.data.testimoni),
                        (context.data.is_show = result.data.is_show);
                } else {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        submessage: result.message,
                        type: "error",
                    });
                }
            });
        },

        async getDetailUserTransaction(email) {
            var context = this;
            this.isLoading = true;
            context.data.student_email = email;

            SalesService.getDetailUserTransaction(email, function (result) {
                context.isLoading = false;

                if (result.success) {
                    if (!context.$route.query.id) {
                        (context.data.student_id = result.data.student_id),
                            (context.data.student_name =
                                result.data.student_name),
                            (context.data.student_picture =
                                result.data.student_picture),
                            (context.url = result.data.student_picture),
                            (context.data.level = result.data.level),
                            (context.data.grade = result.data.grade),
                            (context.packagesList = result.data.packages);
                    } else {
                        context.packagesList = result.data.packages;
                    }
                } else {
                    context.$store.commit("showAlert", {
                        message: `Data siswa tidak ditemukan!`,
                        type: "error",
                    });
                }
            });
        },

        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 300000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 300 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        async upload(e) {
            this.isLoading = true;
            if (this.validateForm()) {
                var file = this.imageFile;

                if (this.data.student_picture && !file) {
                    this.image = this.data.student_picture;
                    if (this.$route.query.id) {
                        this.editData();
                    } else {
                        this.saveData();
                    }
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan pada upload!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET,
                        Key: "testimoni/" + file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan pada upload!`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.data.student_picture = data.Location;
                            if (context.$route.query.id) {
                                context.editData();
                            } else {
                                context.saveData();
                            }
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        saveData: function () {
            var context = this;
            var data = this.data;
            if (this.validateForm()) {
                context.isLoading = true;
                SalesService.createTestimoni(data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        editData: function () {
            var context = this;
            var id = this.queryId;
            var data = this.data;
            this.isLoading = true;
            if (this.validateForm()) {
                SalesService.updateTestimoni(id, data, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Data berhasil disimpan!`,
                            type: "success",
                        });
                        context.$router.go(-1);
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Terjadi Kesalahan!`,
                            submessage: `Data gagal disimpan!`,
                            type: "error",
                        });
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },

        validateForm() {
            var err = false;
            if (!this.data.student_name) {
                this.$store.commit("showAlert", {
                    message: `Nama User wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else {
                if (!this.data.level) {
                    this.$store.commit("showAlert", {
                        message: `Jenjang wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }

                if (!this.data.testimoni) {
                    this.$store.commit("showAlert", {
                        message: `Testimoni wajib diisi!`,
                        type: "error",
                    });
                    err = true;
                }
            }
            return !err;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// TestimoniForm.vue?5eecd7e4